(function ($) {

  function scrollTo($target) {
    if ($target.length > 0 && $target.offset() != null) {
      $('html, body').animate({
        scrollTop: $target.offset().top
      }, 400);
    }
  }

  //////////

  //
  // Handle clicks on anchor links
  //
  $(function () {
    const path = window.location.pathname,
      pattern = new RegExp("^(" + RegExp.escape(path) + ")?#.+")
    ;

    $(document).on('click.jump', 'a', function(e){
      const $a = $(this),
        href = $a.attr('href')
      ;

      // Only handle <a>s with /^#.+/ and /^{{path}}#.+/ where {{path}} is the *current* page
      if (!pattern.test(href)) return;

      // Find the target
      const hash = this.hash,
        $target = $(hash).length > 0 ? $(hash) : $("a[name='" + hash.substr(1) + "']")
      ;
      if (!$target.length) return;

      // We're good to go, let's stop the normal behavior and scroll to the target
      e.preventDefault();
      scrollTo($target);
    });
  });

  //
  // Handle incoming anchors
  //
  if (window.location.hash) {
    $(window).on('load', function() {
      try {
        $target = $(window.location.hash);
        if ($target.length > 0) {
          setTimeout(function(){
            scrollTo($target);
          }, 100);
        }
      } catch(error) { /* do nothing */ }
    });
  }

})(jQuery);

